import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import FileDetailsPreview from '../../../../../../components/FileDetailsPreview'

import { CREATIVE_TYPE_VIDEO, MEDIA_HEIGHT, MEDIA_WIDTH } from '../../../fields'

const AssetMediaSectionPreview = ({ ad }) => {
  const assetLink = ad?.assets?.[0]?.asset?.url

  const fileName = useMemo(() => {
    const width = ad?.dimensions?.[MEDIA_WIDTH]
    const height = ad?.dimensions?.[MEDIA_HEIGHT]
    const type = ad?.type

    if (type === CREATIVE_TYPE_VIDEO) {
      // video file has no dimensions, so just call it 'Video File'
      return 'Video File'
    } else {
      return `${width}x${height}`
    }
  }, [ad])

  if (!assetLink) {
    return null
  }

  return (
    <FileDetailsPreview
      fileName={fileName}
      fileUrl={assetLink}
      filePreviewType={'image'}
      isFileLoading={false}
      allowDelete={false}
    />
  )
}

AssetMediaSectionPreview.propTypes = {
  ad: PropTypes.object
}

export default AssetMediaSectionPreview
